import React from 'react';

/** Keep the recorded precision and explicit time zone visible alongside media. */
const RealtimeMediaTime: React.FC<{ value: string | number }> = ({ value }) => {
  const timestamp = typeof value === 'number' ? new Date(value).toISOString() : value;
  return <time dateTime={timestamp} title={timestamp}>{timestamp.replace('T', ' ').replace(/(?:Z|\+00:00)$/, ' UTC')}</time>;
};

export default RealtimeMediaTime;
